import { RecoilRoot } from "recoil";
import { ThemeProvider } from "styled-components";
import { Routes } from "./core/Routes";
import { GlobalStyleProvider } from "./core/GlobalStyleProvider";
import { theme } from "./styles/theme";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ErrorBoundary from "./error/errorBoundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/react-query";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard } from "./core/AuthGuard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/ko";

import { CustomToastContainer } from "./components/atoms/CostomToastContainer";

declare global {
  interface Window {
    flutter_inappwebview: any;
    imageCropCallback?: (base64Image: string) => void;
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

dayjs.extend(relativeTime);
dayjs.locale("ko");

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RecoilRoot>
        <GlobalStyleProvider>
          <ErrorBoundary>
            <AuthGuard>
              <ThemeProvider theme={theme}>
                <Routes />
                <CustomToastContainer />
              </ThemeProvider>
            </AuthGuard>
          </ErrorBoundary>
        </GlobalStyleProvider>
      </RecoilRoot>
    </QueryClientProvider>
  );
}

export default App;
